import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备开始您的jm下载之旅了吗？
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          无论您是第一次接触jm，还是想了解最新版本的功能，我们的指南都能帮助您顺利完成每一步。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/xiazai-zhinan"
            className="px-8 py-3 bg-background-50 text-primary-600 rounded-md font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看下载指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-600 text-background-50 rounded-md font-medium text-sm hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}